import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoriesSection() {
  const { t } = useTranslation();

  return (
    <section id="categorie" className="py-20 md:py-28 bg-accent-100/50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="mb-14">
          <span className="inline-block bg-background-50 text-foreground-600 text-xs px-4 py-1.5 rounded-full section-label mb-4">
            {t('categories.title')}
          </span>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight max-w-2xl">
            {t('categories.subtitle')}
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat, index) => (
            <a
              key={cat.slug}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-500/40 transition-all cursor-pointer"
            >
              <div className="aspect-[4/3] w-full overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-1">
                  <span className="w-5 h-5 rounded-full bg-accent-500/20 flex items-center justify-center text-[10px] font-label text-accent-700">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                </div>
                <h3 className="font-label text-sm font-semibold text-foreground-900 group-hover:text-accent-700 transition-colors">
                  {cat.name}
                </h3>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}